import 'css-chunksrc/client/scenes/attachDocuments/filesSystem/folderCard/styles.scss';export default {
  "folderCard": "_folderCard_9wb0z_1",
  "folderIcon": "_folderIcon_9wb0z_12",
  "folderInfo": "_folderInfo_9wb0z_17"
};